import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=6065fa00"
import script from "./TemplateForm.vue?vue&type=script&lang=ts"
export * from "./TemplateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports